
import { Line, Bar } from "react-chartjs-2";
import { useState} from 'react';
import {
Chart as ChartJS,
CategoryScale,
LinearScale,
BarElement,
Title,
PointElement,
LineElement,
Tooltip,
Legend,
ArcElement,
} from "chart.js";

ChartJS.register(
ArcElement,  
CategoryScale,
LinearScale,
PointElement,
LineElement,
BarElement,
Title,
Tooltip,
Legend
);

export function PageKonten1({globalOpsi}) {
  const opsiCabang = globalOpsi.opsiCabang;  
  const opsiReport =[
    "Total KM Tempuh",
    "Avg KM Tempuh berdasarkan MT",
    "Pemasangan Ban Baru",
    "Jumlah MT Kelolaan",
    "Jumlah Ban OTF",
    "Jumlah Stok Gudang"
  ]
  const [report, setReport] = useState(opsiReport[0]); 

  const thisMonth = new Date().getMonth()+1; 
  const namaBulan = (x) =>
  new Intl.DateTimeFormat("id-ID", { month: "long" })
    .format(new Date(2026, x - 1, 1));
  const opsiBulan = Array.from({ length: 12 }, (_, i) => ({
    "angka_bln" : thisMonth - i,
    "nama_bulan": namaBulan(thisMonth - i)
  })); 
  

  function Sidebar(){
  return (
  <div className="flex flex-col text-start ml-2">
    <div className="mt-5">
        <div style={{fontSize : '11px'}}>KM Tempuh (YTD)</div>
        <div className="fw-bold fs-3" style={{color : '#8fdaff'}} >410.041</div>
    </div>
    <div className="mt-4">
        <div style={{fontSize : '11px'}}>Growth (YoY)</div>
        <div className="fw-bold fs-3" style={{color : '#8fdaff'}}>10.22%</div>
    </div>
    <div className="mt-4">
        <div style={{fontSize : '11px'}}>Jumlah MT</div>
        <div className="fw-bold fs-3" style={{color : '#8fdaff'}}>1.658</div>
    </div>
    <div className="mt-4">
        <div style={{fontSize : '11px'}}>New MT (YTD)</div>
        <div className="fw-bold fs-3" style={{color : '#8fdaff'}}>122</div>
    </div>
    <div className="mt-4">
        <div style={{fontSize : '11px'}}>Ban OTF</div>
        <div className="fw-bold fs-3" style={{color : '#8fdaff'}}>34.000</div>
    </div>    
  </div>)
  }

  return (<>
    <h2>BUSINESS SCALE</h2>
    <div className="row gap-3">  
        {/* SIDE */}
        <div className="col-md-2 row text-center text-white mb-3 mr-5" 
              style={{ background: "linear-gradient(135deg,#003cff,#00b3ff)", borderRadius: 0 }}>
                <Sidebar />
          </div>    
        <div className="col-md-10">
          <div className="col-md-5">
                <select
                  className="form-select"
                  value={report}
                  onChange={(e)=>setReport(e.target.value)}
                >
                  { 
                    opsiReport.map((x) => (
                    <option key={x} value={x}>{x}</option>
                    ))
                  }
                </select>
              </div>
          {/* BAN GUDANG */}
          <div className="flex justify-content-center col-md-12">
            
            {report === opsiReport[0] && <Bar1 opsiCabang={opsiCabang} opsiBulan={opsiBulan} title={opsiReport[0]} />}
            {report === opsiReport[1] && <Line1 opsiCabang={opsiCabang} opsiBulan={opsiBulan} title={opsiReport[1]}/>}      
            {report === opsiReport[2] && <Bar2 opsiCabang={opsiCabang} opsiBulan={opsiBulan} title={opsiReport[2]} />}
            {report === opsiReport[3] && <Line2 opsiCabang={opsiCabang} opsiBulan={opsiBulan} title={opsiReport[3]} />}
            {report === opsiReport[4] && <Bar2 opsiCabang={opsiCabang} opsiBulan={opsiBulan} title={opsiReport[4]} />}
            {report === opsiReport[5] && <Bar2 opsiCabang={opsiCabang} opsiBulan={opsiBulan} title={opsiReport[5]} />}      
          </div>
        </div>
      
    </div></>
  );
}
//Grafik
function Bar1({opsiCabang, opsiBulan, title}) {
  const thisMonth = new Date().getMonth()+1; 
  const [bulan, setBulan] = useState(thisMonth);

  const formatRibu = (value) => new Intl.NumberFormat("id-ID").format(value);
  const data = {
    labels: opsiCabang.filter(x => x.kode_cabang !== 'C-1').map(x => x.nama_cabang), //16
    datasets: [
      {
        label: "Penjualan",
        data: [
          95000, 140000, 80000, 110000, 50000,
          70000, 60000, 130000, 90000, 100000,
          85000, 75000, 65000, 105000, 115000,
          55000 
        ],
        backgroundColor: [
          "#4e79a7","#f28e2b","#59a14f","#e15759","#76b7b2",
          "#edc949","#af7aa1","#ff9da7","#9c755f","#bab0ab",
          "#1f77b4","#ff7f0e","#2ca02c","#d62728","#9467bd",
          "#8c564b"
        ],
        borderRadius: 3,
      },
    ],
  };

  const options = {
  responsive: true,
  plugins: {
    legend: {
      display: false,
    },
    title: {
      display: false,
    },
    tooltip: {
      callbacks: {
        label: function (context) {
          const total = context.dataset.data.reduce((a, b) => a + b, 0);
          const value = context.raw;
          const percent = ((value / total) * 100).toFixed(2);
          return `${formatRibu(value)} (${percent}%)`;
        },
      },
    },
  },
  scales: {
    y: {
      beginAtZero: true,
      ticks: {
        callback: function (value) {
          return value.toLocaleString("id-ID");
        },
      },
    },
  },
};

  return (
    <div className="mb-3 col-md-12">
        <div className="card mt-2"><div className="card-body">
        <div className="row flex justify-content-end">
            <div className="col-md-3">
                <select
                  className="form-select"
                  value={bulan}
                  onChange={e => setBulan(e.target.value)}
                >
                  { 
                    opsiBulan.map(x => (
                    <option key={x.angka_bln} value={x.angka_bln}>{x.nama_bulan}</option>
                    ))
                  }
                </select>
              </div>
          </div>              
        <Bar data={data} options={options} />
        </div></div>          
    </div>
  );
}

function Line1({opsiCabang, opsiBulan ,title}) {
  const [cabang, setCabang] = useState('');

  const formatRibu = (value) => new Intl.NumberFormat("id-ID").format(value);
  const data = {
    labels: opsiBulan.sort((a,b)=>a.angka_bln - b.angka_bln).map(b => b.nama_bulan),
    datasets: [
      {
        label: "KM",
        data: [75000, 65000, 75000, 71000, 75000, 73000, 76000, 73000, 64000, 73000, 65000, 78000],
        borderColor: "#0d6efd",
        tension: 0.2
      }
    ]
  };
  const options = {
      responsive:true, 
      plugins: { legend: { display:false }}
    };
  
  return (
    <div className="mb-3 col-md-12">
        <div className="card mt-2"><div className="card-body">
             <div className="row flex justify-content-end">
            <div className="col-md-4">
                <select
                  className="form-select"
                  value={cabang}
                  onChange={e => {setCabang(e.target.value)}}
                >
                  <option value = ''>Semua Cabang</option>
                  { 
                    opsiCabang.filter(x => x.kode_cabang !== 'C-1').map(x => (
                    <option key={x.kode_cabang} value={x.nama_cabang}>{x.nama_cabang}</option>
                    ))
                  }
                </select>
              </div>
                </div> 
             <Line data={data} options={options} />     
        </div></div>
                
      </div>
  )
}

function Bar2({opsiCabang, opsiBulan, title}) {
  const thisMonth = new Date().getMonth()+1; 
  const [bulan, setBulan] = useState(thisMonth);
  const [cabang, setCabang] = useState('');

  const formatRibu = (value) => new Intl.NumberFormat("id-ID").format(value);
  const data = {
    labels: opsiCabang.filter(x => x.kode_cabang !== 'C-1').map(x => x.nama_cabang), //16
    datasets: [
      {
        label: "Penjualan",
        data: [
          95000, 140000, 80000, 110000, 50000,
          70000, 60000, 130000, 90000, 100000,
          85000, 75000, 65000, 105000, 115000,
          55000 
        ],
        backgroundColor: [
          "#4e79a7","#f28e2b","#59a14f","#e15759","#76b7b2",
          "#edc949","#af7aa1","#ff9da7","#9c755f","#bab0ab",
          "#1f77b4","#ff7f0e","#2ca02c","#d62728","#9467bd",
          "#8c564b"
        ],
        borderRadius: 3,
      },
    ],
  };

  const options = {
  responsive: true,
  plugins: {
    legend: {
      display: false,
    },
    title: {
      display: false,
    },
    tooltip: {
      callbacks: {
        label: function (context) {
          const total = context.dataset.data.reduce((a, b) => a + b, 0);
          const value = context.raw;
          const percent = ((value / total) * 100).toFixed(2);
          return `${formatRibu(value)} (${percent}%)`;
        },
      },
    },
  },
  scales: {
    y: {
      beginAtZero: true,
      ticks: {
        callback: function (value) {
          return value.toLocaleString("id-ID");
        },
      },
    },
  },
};

  return (
    <div className="mb-3 col-md-12">
        <div className="card mt-2"><div className="card-body">
        <div className="row flex justify-content-end">
            <div className="col-md-4">
                <select
                  className="form-select"
                  value={cabang}
                  onChange={e => {setCabang(e.target.value)}}
                >
                  <option value = ''>Semua Cabang</option>
                  { 
                    opsiCabang.filter(x => x.kode_cabang !== 'C-1').map(x => (
                    <option key={x.kode_cabang} value={x.nama_cabang}>{x.nama_cabang}</option>
                    ))
                  }
                </select>
              </div>
            <div className="col-md-3">
                <select
                  className="form-select"
                  value={bulan}
                  onChange={e => setBulan(e.target.value)}
                >
                  { 
                    opsiBulan.map(x => (
                    <option key={x.angka_bln} value={x.angka_bln}>{x.nama_bulan}</option>
                    ))
                  }
                </select>
              </div>
          </div>              
        <Bar data={data} options={options} />
        </div></div>          
    </div>
  );
}

function Line2({opsiCabang, opsiBulan ,title}) {
  const [cabang, setCabang] = useState('');

  const formatRibu = (value) => new Intl.NumberFormat("id-ID").format(value);
  const data = {
    labels: opsiBulan.sort((a,b)=>a.angka_bln - b.angka_bln).map(b => b.nama_bulan),
    datasets: [
      {
        label: "KM",
        data: [75000, 65000, 75000, 71000, 75000, 73000, 76000, 73000, 64000, 73000, 65000, 78000],
        borderColor: "#0d6efd",
        tension: 0.2
      },
      {
        label: "KM",
        data: [55000, 55000, 55000, 54000, 43000, 34000, 44000, 32000, 80000, 93000, 75000, 88000],
        borderColor: "#2dfd0d",
        tension: 0.2
      }

    ]
  };
  const options = {
      responsive:true, 
      plugins: { legend: { display:false }}
    };
  
  return (
    <div className="mb-3 col-md-12">
        <div className="card mt-2"><div className="card-body">
             <div className="row flex justify-content-end">
            <div className="col-md-4">
                <select
                  className="form-select"
                  value={cabang}
                  onChange={e => {setCabang(e.target.value)}}
                >
                  <option value = ''>Semua Cabang</option>
                  { 
                    opsiCabang.filter(x => x.kode_cabang !== 'C-1').map(x => (
                    <option key={x.kode_cabang} value={x.nama_cabang}>{x.nama_cabang}</option>
                    ))
                  }
                </select>
              </div>
                </div> 
             <Line data={data} options={options} />     
        </div></div>
                
      </div>
  )
}


